import { render, staticRenderFns } from "./aaa_new_my.vue?vue&type=template&id=4f99b8f4&scoped=true&"
import script from "./aaa_new_my.vue?vue&type=script&lang=js&"
export * from "./aaa_new_my.vue?vue&type=script&lang=js&"
import style0 from "./aaa_new_my.vue?vue&type=style&index=0&id=4f99b8f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f99b8f4",
  null
  
)

export default component.exports